import { useMemo } from 'react';
import { useLayoutEditorContext } from '../../../../hooks/context/useLayoutEditorContext';
import { useRequestDataContext } from '../../../../hooks/context/useRequestDataContext';
import { JSONObject } from '../../../../types/types';

export const useLayoutResolveData = (
  workingFormData: JSONObject,
  scope?: string
): JSONObject => {
  const requestData = useRequestDataContext();
  const { canvas } = useLayoutEditorContext();

  const resolveData = useMemo(() => {
    return {
      ...(requestData ?? {}),
      canvas,
      form: workingFormData,
    } as unknown as JSONObject;
  }, [requestData, canvas, workingFormData]);

  return resolveData;
};
